import store from '@/store/index';

export const headers = () => {
  return {
    headers: {
      Authorization: `Bearer ${store.getters['auth/token']}`,
    },
  };
};
